import { useEffect, useState } from "react";

const useCountdown = (countdownProp) => {
  const [countdown, setCountdown] = useState(countdownProp);

  const restartCountdown = () => {
    setCountdown(countdownProp);
  }

  useEffect(() => {
    setCountdown(countdownProp);
  }, [countdownProp]);

  useEffect(() => {
    if (countdown <= 0) return;
    const interval = setInterval(() => {
      setCountdown((c) => c - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [countdown]);

  return {
    countdown,
    restartCountdown,
  }
}

export default useCountdown;